module.exports = __webpack_public_path__ + "static/media/rosa.bb02ec4f.png";